import moment from 'moment'

export default (sessionTime) => {
  const time = moment(sessionTime)

  if (time.isSameOrBefore(moment())) return true

  return false
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/is_session_on_time.js
 **/